import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useOktaAuth } from "@okta/okta-react";
import session from "../session";

export const OktaLogout = () => {
  const { oktaAuth } = useOktaAuth();
  const navigate = useNavigate();
  useEffect(() => {
    const handleLogout = async () => {
      try {
        localStorage.removeItem("coai-conversation");
        session.clear();
        await oktaAuth.signOut();
        navigate("/");
      } catch (error) {
        console.error("Error during logout:", error);
      }
    };

    handleLogout();
  }, [navigate, oktaAuth]);

  return null;
};
